import React from "react";

import { ReactComponent as FacebookNavyCircleIcon } from "../../../../../../images/facebook.svg";
import { ReactComponent as InstagramNavyCircleIcon } from "../../../../../../images/instagram.svg";
import { ReactComponent as TwitterNavyCircleIcon } from "../../../../../../images/twitter.svg";

export const SUB_NAVIGATION_ITEMS = [
  {
    title: "Shop Adults",
    handle: "adults",
    menu: [
      {
        title: "Restore",
        handle: "restore",
        url: "/restore",
        imageBadges: [
          {
            title: "Top Rated",
            backgroundColor: "",
          },
        ],
        image: {
          src: "Nav-Mobile-Restore.jpg",
          alt: "Picture of Restore Product Lit up on a Table",
        },
      },
    ],
  },
  {
    title: "Shop Babies & Kids",
    handle: "babiesKids",
    menu: [
      {
        title: "Rest",
        url: "/rest",
        imageBadges: [
          {
            title: "Best Seller",
            backgroundColor: "",
          },
        ],
        image: {
          src: "Nav-Mobile-Rest.jpg",
          alt: "Picture of Rest Product Lit up on a table",
        },
      },
      {
        title: "Rest+",
        url: "/rest",
        image: {
          src: "Nav-Mobile-RestPlus.jpg",
          alt: "Rest Plus product lit up and on the table",
        },
      },
      {
        title: "Rest Mini",
        url: "/rest-mini",
        image: {
          src: "Nav-Mobile-RestMini.jpg",
          alt: "picture of Rest mini product on a table next to a pillow",
        },
      },
      {
        title: "Shop all Rest products",
        url: "/rest-family",
      },
    ],
  },
];

export const SUB_NAVIGATION_UTILITY_NAV = [
  {
    title: "Blog",
    url: "/blog",
  },
  {
    title: "Accessories",
    url: "/shop-all#accessories-section",
  },
  {
    title: "Shop all products",
    url: "shop-all",
  },
];

export const SUB_NAVIGATION_SOCIAL = [
  {
    icon: <FacebookNavyCircleIcon />,
    url: "https://www.facebook.com/hatchforsleep",
  },
  {
    icon: <InstagramNavyCircleIcon />,
    url: "https://www.instagram.com/hatchforsleep",
  },
  {
    icon: <TwitterNavyCircleIcon />,
    url: "https://twitter.com/hatchforsleep",
  },
];
